import isoWeeksInYear from 'dayjs/plugin/isoWeeksInYear';
import isLapYear from 'dayjs/plugin/isLeapYear';
import isoWeek from 'dayjs/plugin/isoWeek';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import dayOfYear from 'dayjs/plugin/dayOfYear';
import isBetween from 'dayjs/plugin/isBetween';
import dayjs from 'dayjs';

dayjs.extend(isoWeeksInYear);
dayjs.extend(isLapYear);
dayjs.extend(isoWeek);
dayjs.extend(weekOfYear);
dayjs.extend(dayOfYear);
dayjs.extend(isBetween);

export default dayjs;
